var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.apartmentCommentsPermission && _vm.apartmentCommentsPermission.view)?_c('ApartmentComments',{attrs:{"permissions":_vm.apartmentCommentsPermission,"express-view":false,"comments-data":_vm.commentsData,"comment-loading":_vm.commentLoading,"apartment-uuid":_vm.apartment.uuid},on:{"update-comments":_vm.updateComments}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }